'use client';

import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';

// Wrapper so layout.tsx (a Server Component) can dynamic-import FloatingChat with ssr:false.
// Saves ~150kB from initial bundle on every page; chat hydrates after page is interactive.
const Chatt = dynamic(
  () => import('./FloatingChat').then(m => m.FloatingChat),
  { ssr: false }
);

// Signeringssidan för partneravtal ska bara handla om avtalet. En chattbubbla
// över underskriftsrutan hör inte hemma där — och laddas då inte alls.
export function FloatingChat() {
  const sokvag = usePathname() ?? '';
  if (sokvag.startsWith('/partner/avtal/')) return null;
  return <Chatt />;
}
